import React from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { SearchBar } from "../SearchBar";

export const GetStartedModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-xl rounded-2xl bg-white p-8 shadow-2xl">
          <div className="flex justify-end mb-2">
            <button
              onClick={onClose}
              className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          <div className="text-center mb-8">
            <h3 className="text-2xl font-semibold text-slate-900 mb-2">
              Get started with Fluvo
            </h3>
            <p className="text-sm text-gray-500">Enter your website URL...</p>
          </div>

          <SearchBar
            placeholder="yourwebsite.com"
            autoFocus
            onBeforeNavigate={onClose}
          />
        </DialogPanel>
      </div>
    </Dialog>
  );
};
